export const loadingContainerStyles = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  minHeight: 350,
};

export const buttonBlockStyles = {
  display: 'flex',
  width: '100%',
  justifyContent: 'flex-end',
  marginTop: '3rem',
  gap: '3rem',
};

export const projectDetailsContainerStyles = {
  p: '6rem',
  display: 'flex',
  flexWrap: 'wrap',
  rowGap: '24px',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
};

export const projectCardContainerStyles = {
  width: '30%',
  minWidth: 260,
  padding: '24px 16px',
  wordWrap: 'break-word',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};

export const deactivateDescrContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  p: '16px',
};

export const infoIconStyles = {
  width: 16,
  height: 16,
  color: '#0000008c',
};

export const projectFormContainerStyles = {
  display: 'flex',
  p: 3,
  overflowY: 'auto',
  maxHeight: '65vh',
};
